import React from 'react'
import adminheaderStyle from './AdminHeader.module.css'
import mainLogo from '../../../assets/images/logo-new-green.webp'

export default function AdminHeader() {
  return (
    <>
    <div className={adminheaderStyle.adminHeader}>
        <div className={adminheaderStyle.adminheaderContent}>
            <div className={adminheaderStyle.adminheaderTop}> </div>			
            <div className="container">
                <div className={`${adminheaderStyle.adminsubHeader} d-flex flex-wrap align-items-start`}>
                    <a href="/" className={`${adminheaderStyle.adminheaderBrandsection} me-auto`}>
                        <img src={mainLogo} className='img-fluid'/>
                        <div className={`${adminheaderStyle.adminheaderTitles}`}> 
                            <h2> AuthorMeet </h2>
                            <h6> Powered by: &nbsp; Bookworm Central </h6>
                        </div>
                    </a>				
                    <h3> Admin Page </h3>						
                </div>
            </div>
        </div>
    </div>   
    </>
  )
}
